import { FC } from "react";
import { LinkProps as ReactRouterDomLinkProps } from "react-router-dom";

import { StyledLink } from "./styles";

type LinkProps = ReactRouterDomLinkProps;

const Link: FC<LinkProps> = ({ type, ...props }) => {
  return <StyledLink {...props} />;
};

export default Link;
